import { Box, Flex, Text } from '@chakra-ui/react';

interface AccordionTitleProps {
  title: string;
}
const AccordionTitle: React.FC<AccordionTitleProps> = ({ title }) => {
  return (
    <Box width={'100%'}>
      <Flex px={4} py={2} align="center">
        <Text textStyle="headingItem">{title}</Text>
      </Flex>
    </Box>
  );
};

export default AccordionTitle;
